import React from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = ["Outdoor Assembly (Gazebos, pergolas, playgrounds, sheds)", "Furniture Assembly (Beds, IKEA, Wayfair, Amazon furniture)", "Floor & Carpet Removal (Carpet removal, vinyl, laminate, hardwood, engineered wood removal and disposal)", "Deep Carpet Cleaning (Odor removal, deep sanitation, restore freshness)", "Wood Floor Treatment (Cleaning, polishing, restoration, NOT installation)"];
export default function SupplyChainExcellence() {
  return <section data-section-id="187699" id="sacramentos-choice-for-home-renewals" className="bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://above-termite.10web.cloud/wp-content/uploads/2026/04/sourcing_hero_bg.webp" alt="Sacramento Home Renewals" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 py-20 flex flex-col items-center text-center">
        <h1 className="font-default text-4xl md:text-[64px] font-extrabold leading-[1.1] text-white mb-6 tracking-tighter">Outdoor Assembly, Floor Removal &amp; Deep Carpet&nbsp; Cleaning in Sacramento — Done Right the First Time</h1>
        <p className="font-default text-lg md:text-xl text-white/90 mb-12 max-w-2xl mx-auto">We provide gazebo, pergola, playground and shed assembly, carpet and old flooring removal, wood floor treatment and professional deep cleaning with odor removal services in Sacramento and nearby areas.</p>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full mb-12">
          {services.map((service, i) => <div key={i} data-index={i} className="w-full">
              <Button variant="default" className="w-full h-full min-h-[80px] bg-primary/90 hover:bg-primary border border-primary/20 text-primary-foreground py-3 px-4 rounded-lg font-default text-base font-semibold whitespace-normal transition-all shadow-md">
                {service}
              </Button>
            </div>)}
        </div>

        {}
        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild variant="secondary" className="h-auto py-4 px-8 rounded-lg font-default text-base font-semibold shadow-xl bg-primary hover:bg-primary/90 text-primary-foreground transition-all">
            <a href="tel:+16105498900">
              Call Now 
            </a>
          </Button>
          <Button asChild variant="secondary" className="h-auto py-4 px-8 rounded-lg font-default text-base font-semibold shadow-xl bg-chart-3 hover:bg-chart-3/90 text-white transition-all">
          <a href="https://wa.me/16105498900?text=Hi%20I%20need%20a%20quote">
  Message WhatsApp – Sacramento
          </a>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <Link to="#next-section" className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center animate-bounce text-white hover:bg-white/30 transition-colors backdrop-blur-sm" aria-label="Scroll down">
          <ChevronDown className="w-6 h-6" />
        </Link>
      </div>
    </section>;
}